import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Grid } from "antd";
import TradeRoom from "./TradeRoom/TradeRoom";
import TradeRoomMobile from "./mobile/TradeRoomMobile";
import "./App.css";
import click from "../src/Assets/mixkit-old-camera-shutter-click-1137.wav";
import consts from "./consts";
import Pagenofound from "./Pagenofound";
import PrivateRoute from "./PrivateRoute";
import AuthPage from "./AuthPage";

const { useBreakpoint } = Grid;

export default function App() {
  const [onOff, setOnOff] = useState(false);
  const screens = useBreakpoint();
  useEffect(() => {
    const audio = new Audio(click);

    const playSound = () => {
      audio.currentTime = 0;
      audio.play();
    };

    const handleEvent = (e) => {
      if (e.target.closest("#cs") && onOff) {
        playSound();
      }
    };

    document.addEventListener("click", handleEvent);

    return () => {
      document.removeEventListener("click", handleEvent);
    };
  }, [onOff]);

  return (
    <div>
      <Router>
        <Routes>
          {/* Private Routes */}
          <Route path={`/Authpage`} element={<AuthPage />} />

          <Route element={<PrivateRoute />}>
            <Route
              path={`/`}
              element={
                screens.lg ? (
                  <TradeRoom setOnOff={setOnOff} onOff={onOff} />
                ) : (
                  <TradeRoom setOnOff={setOnOff} onOff={onOff} />
                )
              }
            />
          </Route>
          <Route path={`/noaccess`} element={<Pagenofound />} />
        </Routes>
      </Router>
    </div>
  );
}
